import styled from "styled-components";

const Container = styled.div`
  font-size: ${(props) => (props.small ? "0.8em" : "1em")};
  display: grid;
  margin: auto;
  grid-template-columns: 1fr 1fr;
  text-align: center;
  background: #f9f9f9;
  padding: 8px;
  border-radius: 6px;
`;

const Item = styled.button`
  background: ${(props) => (!props.selected ? "transparent" : "#ffb81c")};
  border-radius: 4px;
  border: none;
  padding: 8px 0;
  box-shadow: ${(props) =>
    !props.selected
      ? "none"
      : "0px 4px 8px rgba(242, 169, 0, 0.35)"};
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => (!props.selected ? "#8A8D8F" : "#000000")};
  &:hover {
    opacity: 0.8;
    color: #000000;
  }

  @media (max-width: 576px) {
    font-size: 0.9em;
  }
`;

const ContainerLg = styled.div`
  font-weight: bold;
  font-size: 24px;
  line-height: 24px;
  display: grid;
  margin: auto;
  grid-template-columns: 1fr 1fr;
  text-align: center;
  background: #f9f9f9;
  padding: 8px;
  border-radius: 8px;
  width: 744px;

  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 4px;
  }
`;

const ItemLg = styled.button`
  background: ${(props) => (!props.selected ? "transparent" : "#ffb81c")};
  border-radius: 8px;
  border: none;
  padding: 22px 0;
  box-shadow: ${(props) =>
    !props.selected
      ? "none"
      : "0px 4px 8px rgba(242, 169, 0, 0.35)"};
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  color: ${(props) => (!props.selected ? "#8A8D8F" : "#000000")};
  &:hover {
    opacity: 0.8;
    color: #000000;

    .icon{
      fill: #000000;
    }
  }

  @media (max-width: 576px) {
    padding: 8px 0;
  }

  .icon{
    width: 32px;
    height: 32px;
    fill: ${(props) => (!props.selected ? "#8A8D8F" : "#000000")};
    @media (max-width: 576px) {
      width: 14px;
      height: 14px;
    }
  }

  @media (max-width: 576px) {
    font-weight: bold;
    font-size: 12px;
    line-height: 20px;
  }
`;

const Tab = { Container, ContainerLg, Item, ItemLg };

export default Tab;
